/* eslint-disable no-nested-ternary */
import {
  Default as _, match,
} from '@nike/rcf-fp';
import PropTypes from 'prop-types';
import React from 'react';

function getStoreVATId(taxes) {
  return taxes?.find((t) => t.Tax)?.Tax?.VATIdentifiers?.find((vat) => vat?.Type === 'StoreVATId')?.Value || '';
}

const TaxRegistrationNumber = ({
  country, invoiceNumber, posID, locale, siretNumber, taxes
}) => {
  const isPTorZAForDEorCZ = ['PRT', 'ZAF'].includes(country) || locale === 'de-DE' || locale === 'cs-CZ' || locale === 'he-IL';
  const StoreVATId = isPTorZAForDEorCZ ? getStoreVATId(taxes) : '';

  const taxInformationByCountry = (countryCode) => match(countryCode)(
    ['AUS', { taxNumber: 'ABN: 99-055-141-743', taxStatement: 'TAX INVOICE' }],
    ['MYS', { taxStatement: 'Company Reg. No.: 198708-M' }],
    ['SGP', { taxStatement: 'GST Reg No.: M90367331L' }],
    ['THA', { taxStatement: 'Tax ID No.: 0105540077511' }],
    [() => ['PRT', 'ZAF'].includes(countryCode), { taxStatement: StoreVATId ? `Store VAT: ${StoreVATId}` : '' }],
    [_, '']
  );

  const taxInformationByLocale = (localeCode) => match(localeCode)(
    ['ca-ES', { taxStatement: 'N.I.F: W-0031639-H' }],
    ['cs-CZ', { taxStatement: StoreVATId ? `Obch. DPH: ${StoreVATId}` : 'Obch. DPH: CZ26764083' }],
    ['da-DK', { taxStatement: 'Butiks momsnr: DK20136677' }],
    ['de-AT', { taxStatement: 'Shop-MwSt.: ATU46008706' }],
    [() => ['de-CH', 'fr-CH', 'it-CH'].includes(localeCode), { taxNumber: 'Nike Retail B.V. Hilversum', taxStatement: 'P.IVA punto vendita: CHE-108.443.755 MWST' }],
    ['de-DE', { taxStatement: StoreVATId ? `Shop-MwSt.: ${StoreVATId}` : '' }],
    ['en-GB', { taxStatement: 'Store VAT: GB636510746' }],
    ['en-IE', { taxStatement: 'Store VAT: 95 14 666 C' }],
    ['en-NZ', { taxNumber: 'IRD: 56-998-101', taxStatement: 'TAX INVOICE' }],
    ['es-ES', { taxStatement: 'N.I.F: W-0031639-H' }],
    ['fr-BE', { taxStatement: 'TVA magasin: BE 0458.053.004' }],
    ['fr-FR', { siretNumber: siretNumber ? `Siret: ${siretNumber}` : '', taxNumber: 'No TVA: FR 8140539518', taxStatement: 'NAF: 4771Z' }],
    ['hr-HR', { taxStatement: 'PDV prodajnog mjesta: 82250928351' }],
    ['nl-BE', { taxStatement: 'Btw store: BE 0458.053.004' }],
    ['nl-NL', { taxStatement: 'Btw store: 8043.00.549.B.01' }],
    ['nn-NO', { taxStatement: `Fakturanummer: ${invoiceNumber}` }],
    ['pl-PL', { taxStatement: 'Store NIP 5263095905' }],
    ['pt-PT', { taxNumber: 'Nike Retail BV-Sucursal em Portugal C.C. Freeport - Av. Euro 2004 , loja H6 2890-154 Alcochete', taxStatement: 'No Contribuinte: PT980174759' }],
    ['sv-SE', { taxStatement: 'Storemoms: SE516402-811901' }],
    ['he-IL', { taxStatement: StoreVATId ? `עוסק מורשה: ${StoreVATId}` : '' }],
    [_, '']
  );

  const taxInformation = locale ? taxInformationByLocale(locale) : taxInformationByCountry(country);

  return (
    <>
      <p>{taxInformation.siretNumber}</p>
      <p>{taxInformation.taxStatement}</p>
      <p>{taxInformation.taxNumber}</p>
      {country === 'THA' && posID ? <p>POS ID: {posID}</p> : '' }
      {country === 'THA' && invoiceNumber ? <p>Tax Invoice No: {invoiceNumber}</p> : '' }
      <br />
    </>
  );
};

TaxRegistrationNumber.defaultProps = {
  country: '',
  invoiceNumber: '',
  locale: '',
  posID: '',
  siretNumber: '',
  taxes: [],
};

TaxRegistrationNumber.propTypes = {
  country: PropTypes.string,
  invoiceNumber: PropTypes.string,
  locale: PropTypes.string,
  posID: PropTypes.string,
  siretNumber: PropTypes.string,
  taxes: PropTypes.arrayOf(PropTypes.shape()),
};

export default TaxRegistrationNumber;
